import React from 'react';
import { Dialog, dialogClasses, type DialogProps, styled } from '@mui/material';
import { mergeSx } from 'merge-sx';

import { height as appBarHeight } from '@/theme/components/MuiAppBar';

const MODAL_MARGIN_TOP = 2;
const MODAL_MARGIN_BOTTOM = 4;
const MODAL_MARGIN_HORIZONTAL = 4;
const MODAL_MAX_WIDTH = 1168;

const CommonDialog = styled((props: DialogProps) => (
  <Dialog
    {...props}
    sx={mergeSx(
      ({ spacing }) => ({
        [`.${dialogClasses.paper}`]: {
          mt: appBarHeight + MODAL_MARGIN_TOP,
          mb: MODAL_MARGIN_BOTTOM,
          mx: MODAL_MARGIN_HORIZONTAL,
          height: `calc(100vh - ${spacing(appBarHeight + MODAL_MARGIN_TOP + MODAL_MARGIN_BOTTOM)})`,
          width: `calc(100vw - ${spacing(MODAL_MARGIN_HORIZONTAL * 2)})`,
          maxWidth: MODAL_MAX_WIDTH
        }
      }),
      props.sx
    )}
  />
))({});

export default CommonDialog;
